import get from "lodash.get";
import { logSessionInfo } from "../../../services/logger";
import { PRE_CHECK_MACHINE_STATES } from "../constants";
import { flattenReaderManagerState, flattenStudentPreCheckContextState, flattenStudentPreCheckState } from "./readyModuleLogDataTransform";

const events = {
    READY_MODULE_BEGIN: "READY_MODULE_BEGIN",
    READY_MODULE_END: "READY_MODULE_END",
    READY_MODULE_ERROR: "READY_MODULE_ERROR",
    READY_MODULE_TROUBLESHOOT: "READY_MODULE_TROUBLESHOOT",
}

/**
 * Log for over all check starts
 */
export function logStartStudentPreChecks(action, listenerApi){
    const { studentPreChecks } = listenerApi.getState()

    const loggedData = {
        event: events.READY_MODULE_BEGIN,
        eventItem: studentPreChecks.currentCheck,
        ...flattenStudentPreCheckState(studentPreChecks),
        ...flattenStudentPreCheckContextState(studentPreChecks)
    }

    readyModuleLog(getActionName(action.type), loggedData, listenerApi.getState())
}

/**
 * Log for overall check ends
 */
export function logEndStudentPreChecks(action, listenerApi){
    const { studentPreChecks, readerManager } = listenerApi.getState()
    
    const loggedData = {
        event: events.READY_MODULE_END,
        eventItem: studentPreChecks.currentCheck,
        ...flattenStudentPreCheckState(studentPreChecks),
        ...flattenStudentPreCheckContextState(studentPreChecks),
        ...flattenReaderManagerState(readerManager),
    }

    readyModuleLog(getActionName(action.type), loggedData, listenerApi.getState())
}

/**
 * Log for each individual check item encountered error
 */
export function logPreCheckItemErrored(action, listenerApi){
    const { studentPreChecks, readerManager } = listenerApi.getState()
    
    const loggedData = {
        event: events.READY_MODULE_ERROR,
        eventItem: studentPreChecks.currentCheck,
        errorMessage: action.payload,
        ...flattenStudentPreCheckState(studentPreChecks),
        ...flattenStudentPreCheckContextState(studentPreChecks),
        ...flattenReaderManagerState(readerManager, studentPreChecks.currentCheck),
    }

    readyModuleLog(`${getActionName(action.type)}_${studentPreChecks.currentCheck}`, loggedData, listenerApi.getState())
}

export function logPreCheckEvent(action, listenerApi){
    if(!action.payload || !action.payload.event){
        console.warn("logPreCheckEvent requires action.payload.event name", action.payload)
        return
    }

    const { studentPreChecks, readerManager } = listenerApi.getState()
    const event = action.payload.event
    const eventCheckItem = action.payload.item
    const count = get(studentPreChecks, `contextStates.logCount.${eventCheckItem}_${event}`, 0)

    const loggedData = {
        event: event,
        eventItem: eventCheckItem,
        eventCount: count,
        ...flattenStudentPreCheckState(studentPreChecks),
        ...flattenStudentPreCheckContextState(studentPreChecks),
        ...flattenReaderManagerState(readerManager, studentPreChecks.currentCheck),
    }

    readyModuleLog(`${getActionName(action.type)}_${event}_${eventCheckItem}`, loggedData, listenerApi.getState())
}

export function logTroubleshootData(action, listenerApi){
    const { studentPreChecks, readerManager } = listenerApi.getState()

    const loggedData = {
        event: events.READY_MODULE_TROUBLESHOOT,
        eventItem: studentPreChecks.currentCheck,
        actionPayload: action.payload,
        ...flattenStudentPreCheckState(studentPreChecks),
        ...flattenStudentPreCheckContextState(studentPreChecks),
        ...flattenReaderManagerState(readerManager, studentPreChecks.currentCheck),
    }

    readyModuleLog(`${getActionName(action.type)}_${action.payload.type}`, loggedData, listenerApi.getState())
}

/**
 * General log for use within the ready module
 */
function readyModuleLog(keyName, loggedData, states){
    try{ 
        const districtId = get(states, 'studentPreChecks.settings.sessionData.districtId')
        const studentId = get(states, 'studentPreChecks.settings.sessionData.userId', '').replaceAll("-", '').toUpperCase()
        const currentDate = new Date()

        const paddedData = {
            timestamp: Date.now(),
            ...loggedData
        }

        logSessionInfo(`ready_${keyName}`, paddedData)
        logSessionInfo(`ready_${studentId}_${keyName}`, paddedData, `ready_module_v2/districtid=${districtId}/year=${currentDate.getUTCFullYear()}/month=${currentDate.getUTCMonth()+1}/day=${currentDate.getUTCDate()}`)
    }catch(err){
        console.error('Problem logging ready module', err)
    }
}
function getActionName(actionType){
    try{
        return actionType.match(/([a-zA-Z]*)\/([a-zA-Z]*)/)[2]
    }catch(err){
        return ""
    }
}